// TODO: remove when the European market opening period ends (US-5562)
import { useMemo } from 'react';
import { useSearchParams } from '@framework/next/navigation';
import Market from '@/creditflowresearch/domain/Market';
import Region from '@/creditflowresearch/domain/Region';
import Product from '@/creditflowresearch/domain/Product';
import { isOpenMarketDealRequest } from './isOpenMarketDealRequest';

export const useOpenStatusGroups = (): boolean => {
  const searchParams = useSearchParams();
  const markets = searchParams?.get('markets') ?? null;
  const regions = searchParams?.get('regions') ?? null;
  const products = searchParams?.get('products') ?? null;

  return useMemo(() => isOpenMarketDealRequest({
    marketIds: Market.getIds(markets),
    regionIds: Region.getIds(regions),
    productIds: Product.getIds(products),
  }), [markets, regions, products]);
};
